export default __webpack_public_path__ + "static/media/pexels-photo-7195122.9dd8cc35.jpeg";